module.exports = __webpack_public_path__ + "img/two1Red.f0de8344.png";